import Relay from '@/components/Relay'
import { Button } from '@/components/ui/button'
import SecondaryPageLayout from '@/layouts/SecondaryPageLayout'
import { normalizeUrl, simplifyUrl } from '@/lib/url'
import { usePrimaryPage } from '@/PageManager'
import { HugeiconsIcon } from '@hugeicons/react'
import { ArrowUpRight01Icon } from '@hugeicons/core-free-icons'
import { forwardRef, useMemo, useEffect } from 'react'
import NotFoundPage from './NotFoundPage'
import { useTranslation } from 'react-i18next'
import { useAtomValue } from 'jotai'
import { isSmallScreenAtom } from '@/atoms/screenSize'

const RelayPage = forwardRef(({ url, index }: { url?: string; index?: number }, ref) => {
  const { t } = useTranslation()
  const normalizedUrl = useMemo(() => (url ? normalizeUrl(url) : undefined), [url])
  const isSmallScreen = useAtomValue(isSmallScreenAtom)
  const { navigate } = usePrimaryPage()

  useEffect(() => {
    if (!normalizedUrl) return
    document.title = t('Relay {{url}} on {{appName}}', {
      url: simplifyUrl(normalizedUrl),
      appName: window.hallway.universe.appName
    })
    history.replaceState(null, '')
  }, [normalizedUrl])

  if (!normalizedUrl) return <NotFoundPage ref={ref} />

  return (
    <SecondaryPageLayout
      ref={ref}
      index={index}
      title={url ? simplifyUrl(url) : undefined}
      displayScrollToTopButton
      controls={
        !isSmallScreen && (
          <Button
            variant="ghost"
            size="titlebar-icon"
            onClick={() => navigate('relay', { url: normalizedUrl })}
            title={t('Open in primary panel')}
          >
            <HugeiconsIcon icon={ArrowUpRight01Icon} />
          </Button>
        )
      }
    >
      <Relay url={normalizedUrl} />
    </SecondaryPageLayout>
  )
})
RelayPage.displayName = 'RelayPage'
export default RelayPage
